import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';
import 'inobounce';
import axios from 'axios';
import { merge } from 'ramda';
import App from './App';
import router from './router';

// import suggest from 'suggest'

// import FastClick from 'fastclick'
// FastClick.attach(document.body);
import {
  ddbridge,
  ddbridgebeatles,
  ddbridgedriver,
} from './bridge';

console.log(ddbridgedriver,ddbridgebeatles);


// alert(window.navigator.userAgent.toLowerCase());
const isIOS = window.didi.is('ios');

window.setTitle = (title) => {
  if (isIOS) {
    if (ddbridge.is('driver')) {
      ddbridgedriver.call('controllerTitle', { vctitle: title });
    }
    // 主端 顺风车，顺风车独立端
    if (ddbridge.is('blord') || ddbridge.is('beatles')) {
      ddbridgebeatles.updateNaviTitle({
        navi_title: title,
      });
    }
  } else {
    window.document.title = title;
  }
};

// 孙昊 2018-07-25
const parseJson = (data) => {
  if (data.constructor.name === 'String') {
    return JSON.parse(data);
  }
  return data;
};


// 孙昊 2018-07-25
// ddbridge、ddbridgebeatles、ddbridgedriver 均可单独调用
// tools 下的方法均已抹平容器判断。直接调用即可
window.epowerTools = {
  ddbridge,
  ddbridgebeatles,
  ddbridgedriver,
  tools: {
    getLocationInfo: (cb) => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('getLocationInfo', (res) => {
          cb(parseJson(res));
        });
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.getLocationInfo((res) => {
          cb(parseJson(res));
        });
      } else {
        cb({ cityid: 1 });
      }
    },
    getUserInfo: (cb) => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('getUserInfo', (res) => {
          cb(parseJson(res));
        });
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.getUserInfo((res) => {
          cb(parseJson(res));
        });
      }
    },
    initEntrance: (params, cb) => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('initEntrance', params, (res) => {
          if (cb) {
            cb(res);
          }
        });
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.initEntrance(params, (res) => {
          if (cb) {
            cb(res);
          }
        });
      }
    },
    invokeEntrance: () => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('invokeEntrance');
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.invokeEntrance();
      }
    },
    launchScan: (params = {}, cb) => {
      // 扫码
      // 孙昊 2018-07-25
      // 车生活 司机端
      if (ddbridge.is('driver>=5.0.22')) {
        ddbridgedriver.call('launchScan', params, (res) => {
          if (cb) {
            cb(parseJson(res));
          }
        });
      } else if (ddbridge.is('beatles>=5.2.12') || ddbridge.is('blord>=2.0')) {
        ddbridgebeatles.callNative('scanQRCode',{}, (res) => {
          // alert(parseJson(res).data);
          cb({ ret: parseJson(res).data });
        });
      } else {
        // 都不支持扫码
        alert('软件版本过低！请升级！');
      }
    },
    launchNav: (params = {}) => {
      // 唤起路径规划
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('launchNav', params);
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        // ddbridgebeatles.callNative('launchNav', params);
        ddbridgebeatles.launchNav(params);
      }
    },
    openPage: (url) => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('openPage', {
          url,
          newWindow: true,
          browser: false,
          isArouseRadio: true
        });
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.schemes.jump('/beatles_webpage', {
          weburl: url
        });
      }
    },
    closePage: () => {
      if (ddbridge.is('driver')) {
        ddbridgedriver.call('pageClose');
      } else if (ddbridge.is('blord') || ddbridge.is('beatles')) { // 顺风车
        ddbridgebeatles.closePage();
      }
    },
  },
};

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VueResource);
// Vue.use(suggest);

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    window.setTitle(to.meta.title);
  }
  next();
});

// window.$originV = new Vue({
//   el: '#app',
//   router,
//   store,
//   template: '<App/>',
//   components: { App }
// });

// function getCity() {
//   return new Promise((resolve, reject) => {
//     if(didi.dbridge.support('getLocationInfo')){
//       didi.dbridge.getLocationInfo(function(result){
//         axios.get("/station-api/station/getcityinfo?lat=" + result.lat + "&lng=" + result.lng).then((response) => {
//           resolve(response.data.data);
//         })
//       })
//     }else{
//       resolve({cityid: 1});
//     }
//   })
// }

// 获取城市的方法
const getCityInfo = (params, cb) => {
  const { lat, lng } = params;
  axios.get(`https://gw.am.xiaojukeji.com/station-api/station/getcityinfo?lat=${lat}&lng=${lng}`, {headers:{ticket: params.ticket}}).then((response) => {
    cb(response.data.data);
  }, () => {
    cb({
      cityid: 1,
      cityname: '北京',
    });
  });
};

// alert(JSON.stringify(ddbridge.app));

// 从端内获取城市信息
const getCity = (ticket) => new Promise((resolve) => {
  window.epowerTools.tools.getLocationInfo((res) => {
    let params = {...res, ticket};
    getCityInfo(params, (data) => {
      resolve(data);
    });
  });
});

function getUid(tk) {
  axios.get(`https://gw.am.xiaojukeji.com/station-api/common/queryuserbytoken?token=${tk}`, {headers: {ticket: tk}}).then((res) => {
    if (res && res.data && res.data.data && res.data.data.errno === 0) {
      window.epuid = res.data.data.uid;
    }
  });
}

function getQueryString(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return unescape(r[2]);
  }
  return null;
}

const getUserInfo = () => {
  const source = getQueryString('source');
  const stationId = getQueryString('stationId');
  const ticket = getQueryString('token');
  const phone = getQueryString('phone');
  return new Promise((resolve) => {
    if (window.location.search.indexOf('debug') !== -1) {
      resolve({
        ticket,
        phone,
        source,
        stationId,
      });
      getUid(ticket);
    } else {
      window.epowerTools.tools.getUserInfo((res) => {
        const result = {
          ...res,
          source,
          stationId,
        };
        resolve(result);
        getUid(result.ticket);
      });
    }
  });
};

// function getA3() {
//   return new Promise((resolve, reject) => {
//     if(didi.dbridge.support('getA3Token')){
//       didi.dbridge.getA3Token(function(result){
//         resolve(result);
//       })
//     }else{
//       resolve({});
//     }
//   })
// }

function vueInit(ticket, phone, source, stationId, cityid, cityname, a3, imei, isAllow) {
  // vuex 初始化
  const store = new Vuex.Store({
    state: {
      source,
      isAllow,
      token: ticket,
      phone,
      cityName: cityname,
      cityId: cityid,
      a3,
      imei,
      userPosition: {},
      stateData: {
        lat: 40.04387586805556,
        lng: 116.28963460286458,
        type: 2,
        distance: 5,
      },
      stationListData: [],
      cardboxState: 0,
      showStationDetail: false,
      stationDetailData: {},
      orderInfo: {
        orderStatus: -1,
      },
      qrCodeInfo: {},
      infoPics: {
        current: null,
        showPics: false,
        pics: [],
      },
      findstationDoing: false,
      errDialogInfo: {
        show: false,
      },
      elecPriceInfo: { },
      showChargeState: true,
      pricePopupInfo: {
        show: false,
        priceInfos: [],
      },
      feedbackPopupInfo: {
        show: false,
      },
      achieveInfo: [],
      totalBalance: 0.0,
      // 搜索后直接展示详情页的宏操作开关
      showDetailMacroSwitch: false, // false || string: id
      redPoint: {},
      // 桩站id
      fullStationId: stationId,
      // 首次进入
      firstEntry: 0,
      eVIsFetching: true,
    },
    mutations: {
      fullStationIdChange(state, newData) {
        state.fullStationId = newData;
      },
      firstEntryChange(state,newData){
        state.firstEntry = newData;
      },
      changeShowDetailMacroSwitch(state, newData){
        state.showDetailMacroSwitch = newData;
      },
      changeRedPoint(state,newData){
        state.redPoint=merge(state.redPoint,newData);
      },
      changeTotalBalance(state,newData){
        state.totalBalance=newData;
      },
      changeAchieveInfo(state,newData){
        state.achieveInfo=newData;
      },
      changePricePopupInfo(state, newData){
        state.pricePopupInfo = merge(state.pricePopupInfo, newData);
      },
      changeFeedbackPopupInfo(state, newData){
        state.feedbackPopupInfo = merge(state.feedbackPopupInfo, newData);
      },
      changeUserPosition(state, newData){
        state.userPosition = merge(state.userPosition, newData);
      },
      changeShowChargeState(state,newData){
        state.showChargeState=newData;
      },
      tokenChanged(state, newData) {
        state.token = newData;
      },
      dataChanged(state, newData) {
        state.stateData = merge(state.stateData, newData);
      },
      dataCover(state, newData) {
        state.stateData = newData;
      },
      stationListDataChanged(state, newData) {
        state.stationListData = newData;
      },
      cardboxStateChanged(state, newData){
        state.cardboxState = newData;
      },
      stationDetailDataChanged(state, newData){
        state.stationDetailData = merge(state.stationDetailData,newData);
      },
      showStationDetailChanged(state, newData){
        state.showStationDetail = newData;
      },
      orderInfoChanged(state, newData){
        /*newData.stationName || (newData.stationName = state.orderInfo.stationName);
        newData.soc || (newData.soc = state.orderInfo.soc);*/
        state.orderInfo = merge(state.orderInfo, newData);
      },
      qrCodeInfoChanged(state, newData){
        state.qrCodeInfo = merge(state.qrCodeInfo, newData);
      },
      infoPicsChanged(state, newData){
        state.infoPics = merge(state.infoPics, newData);
      },
      findstationDoingChanged(state, newData){
        state.findstationDoing = newData;
      },
      errDialogInfoChanged(state, newData){
        state.errDialogInfo =  newData;
      },
      showTopHornChanged(state, newData){
        state.showTopHorn = newData;
      },
      elecPriceChange(state,newData){
        state.elecPriceInfo=merge(state.elecPriceInfo,newData);
      },
      eVIsFetchingChange(state,newData){
        state.eVIsFetching = newData;
      }
    },
    actions:{
      getOneInfo({state},searchDetailData){
        return new Promise((resolve)=>{
          axios.get('https://gw.am.xiaojukeji.com/station-api/station/getoneinfo', {params: searchDetailData, headers: {ticket: searchDetailData.token}}).then((res) => {
            resolve(res.data.data);
          });
        });
      },
      getConnectorList({state},connectorData){
        return new Promise((resolve) => {
          axios.post('https://gw.am.xiaojukeji.com/station-api/connector/querylist',connectorData, {
            headers: {ticket: connectorData.token}
          }).then((res) => {
            resolve(res.data.data);
          });
        });
      },
      showDetail({dispatch,commit,state},fullStationId){
        commit('findstationDoingChanged', true);
        let searchDetailData={
          fullstationid:fullStationId,
          token:state.token,
          lat: state.stateData.lat,
          lng: state.stateData.lng,
          userlat: state.userPosition.lat,
          userlng: state.userPosition.lng,
          source: state.source
        };
        let connectorData = {
          fullStationId: fullStationId,
          token: state.token
        };
        Promise.all([dispatch('getOneInfo',searchDetailData),dispatch('getConnectorList',connectorData)]).then((res)=>{
          commit('showStationDetailChanged', true);
          commit('findstationDoingChanged', false);
          commit('stationDetailDataChanged', res[0]);
          commit('stationDetailDataChanged', res[1]);
        });
      },
      /*equipmentValidate({commit,state},params){
        if(state.eVIsFetching){
          commit('eVIsFetchingChange',false);
          window.setTimeout(() => {
            commit('eVIsFetchingChange',true);
          },10000);
          axios.post('/paycenter-api/charge/equipmentvalidate', {...params.qrCodeInfoLocal}).then((res) => {
            commit('eVIsFetchingChange',true);
            if (String(res.data.code) === '10000') {
              commit('elecPriceChange', res.data.data);
              commit('orderInfoChanged', {orderStatus: 0});
              params.getPlateInfo(res.data.data.plateNumber,res.data.data.skipInputPn);
              let priceStage=res.data.data.priceStage.map((item) => {
                return { time: item.startTime + '-' + item.endTime,
                  elecPrice: item.marketElePrice,
                  servPrice: item.marketServPrice
                }
              });
              commit('changePricePopupInfo', {priceInfos: priceStage});
              params.statusOmegaReport();
              if(res.data.data.skipInputPn == 0 && res.data.data.freeParkType == 3){
                Omega.trackEvent('before_plate_page_sw');
              }
            } else if(String(res.data.code) === '10005'){
              Omega.trackEvent('charge_precharge_connecterror_sw', merge({
                errorid: res.data.code,
                errorMsg: res.data.msg
              }, qrCodeInfoLocal));
              params.showErrAction(res,'网络异常');
            } else {
              Omega.trackEvent('charge_precharge_connecterror_sw', merge({
                errorid: res.data.code,
                errorMsg: res.data.msg
              }, params.qrCodeInfoLocal));
              params.showErrAction(res,'错误');
            }
          });
        }else{
          params.showErrAction({data:{msg:'扫码过于频繁，请10秒后重试'}},'提示');
        }
      }*/
    }
  });

  document.cookie = `ticket=${ticket};path=/`;

  // omega 初始化
  window.Omega.enableClickFilterTracker({
    attr: 'track-data',
  });

  window.Omega.addTrackHandler(() => {
    if (!window.epower_cid) {
      window.epower_cid = getQueryString('epower_cid') || '';
    }
    return {
      cityid,
      area: cityname,
      epower_cid: window.epower_cid,
      uid: window.epuid,
    };
  });

  window.Omega.trackEvent('charge_loading_page_sw');
  const v = new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App },
  });
}

const run = async () => {
  const { ticket, phone, source, stationId } = await getUserInfo();
  const { cityid, cityname } = await getCity(ticket);
  window.Apollo.getToggle({
    // debug: true,
    name: 'entrance_admin',
    key: ticket,
    phone,
    city: cityid,
  }, (result) => {
    if (!result.code) {
      const ABTest = result.data.entrance_admin;

      // alert(`${JSON.stringify({ticket, phone, source, stationId, cityid, cityname})}`);
      if (ABTest.isAllow()) {
        vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, true);
      } else {
        vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, false);
      }
    }
  });
}
run();

// Promise.all([getUserInfo(), getCity()]).then((res) => {
//   const [
//     {
//       ticket,
//       phone,
//       source,
//       stationId,
//     },
//     { cityid, cityname },
//   ] = res;
//   alert(`init:${JSON.stringify(res)}`);
//   window.Apollo.getToggle({
//     // debug: true,
//     name: 'entrance_admin',
//     key: ticket,
//     phone,
//     city: cityid,
//   }, (result) => {
//     if (!result.code) {
//       const ABTest = result.data.entrance_admin;
//       if (ABTest.isAllow()) {
//         vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, true);
//       } else {
//         vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, false);
//       }
//     }
//   });
// });



// WEBPACK FOOTER //
// ./src/pages/epower/epower.js